<!--
  LISTA DE NEGOCIOS SEM DATA PREVISTA
-->


<template>
    <div class="guia-popover" style="width: 300px;">
        <div>
            <div class="guia-popover-content">
                <div class="row mx-auto align-items-center" style="border-bottom: 1px solid gray">
                    <div class="col-12 p-2" @click="handleMinimizar" style="cursor: pointer">
                        <span class="guia-title w-100"> Negócios sem data prevista informada</span>
                        <i class="guia-title text-right pl-3 fa" :class="{ 'fa-chevron-circle-up': minimizado, 'fa-chevron-circle-down': !minimizado }" aria-hidden="true"></i>
                        <div class="w-100"></div>
                        <span class="card-text">{{ total.count_negocios }} Negócios</span>
                        <span class="card-value">{{ total.total | formatValue(2) }} </span>
                    </div>
                </div>
                <div v-if="!minimizado" class="guia-list">
                    <div class="guia-list__content">
                        <crm-card v-for="(negocio, index) in negocioList" :key="index" :negocio="negocio"
                            @edit="handleEditNegocio(negocio.codnegocio)"></crm-card>
                    </div>
                </div>
            </div>
        </div>
<!-- 
        <transition name="fade">
            <div v-if="currVideo" class="guia-video" @click="currVideo = null">
                <div class="guia-video-content text-center" style="width: 650px">
                    <div class="row col justify-content-end">
                        <button type="button" class="close" @click="handleCloseVideo" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <iframe width="560" height="315" :src="currVideo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="max-width: 800px"></iframe>
                </div>
            </div>
        </transition>
 -->
    </div>
</template>


<script>

import { apiORDSapp } from '../shared/api-functions'
import { SysVars } from '../main'
import CrmCard from './crm-card'

export default {
    props: {
        
    },

    components: {
        CrmCard
    },

    data() {
        return {
            minimizado: true,
        }
    },

    computed: {

        negocioList: function () {
            return this.$store.getters.getNegocioNoDateTimelineList.lista
        },

        total: function () {
            if (this.$store.getters.getNegocioNoDateTimelineList.total.length > 0)
              return this.$store.getters.getNegocioNoDateTimelineList.total[0]
            else 
              return []
        },

    },

    methods: {

        handleMinimizar () {
            this.minimizado = !this.minimizado
        },

        handleFecharGuia () {

        },

    },

    watch: {

    },

    beforeCreate () {

    },

    mounted () {
            console.log(this.negocioList)
            
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
        })
    },

    created () {
    }

}

</script>




<style scoped>

.guia-popover {
    position: fixed; 
    top: auto; 
    left: auto; 
    bottom: 20px; 
    left: 20px; 
    display: inline-flex;
    align-items: center;
    z-index: 1;
    flex-direction: row;
}

.guia-popover-content {
    width: 100%;
    color: #26292c;
    background-color: #fff;
    box-shadow: 0 0 2px 0 #0000003d, 0 8px 10px 1px #0000000d, 0 3px 14px 2px #0000000f, 0 5px 5px -3px rgba(0,0,0,.1);
    order: 2;
}

.guia-list {
    max-height: 400px;
    display: flex;
    flex-direction: column;
}

.guia-list__content {
    overflow-y: auto;
    flex: 1 1 auto;
    padding: 8px 0;
    background-color: rgb(233, 233, 233);
}

.guia-title {
    font-size: 18px;
    color: #2b6292;
}


.guia-video {
    position: fixed;
    z-index: 9998;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(15,43,73,.25);
    display: flex;
    transition: opacity .3s ease;
    align-items: center;
    justify-content: center;
}

.guia-icon {
    cursor: pointer;
}


</style>



// WEBPACK FOOTER //
// src/forms-crm/crm-painel-timeline-teste.vue